<template>
    <v-card v-if="category && product"
            tile
            flat
            class="pa-2 fill-height d-flex flex-column relative">
        <v-img v-if="product.image && product.image.source" :src="product.image.source" :aspect-ratio="4/1"></v-img>
        <div class="py-0 pt-2 headline text-center font-weight-bold" :class="{ 'px-5': highlighted }">
            {{ product.title }}
        </div>
    </v-card>
    <v-card v-else-if="product && !category"
            tile
            flat
            class="pa-2 fill-height d-flex flex-column"
            :class="{ 'pb-4': highlighted }"
            :to="{ name: 'product', params: { productId: product.id }}">


        <div class="position-relative overflow-hidden">
            <div v-if="product.is_new" class="new-badge body-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.shop.new') }}</div>
            <v-img :src="productImageSrc(product)"
                   class="flex-grow-0"
                   aspect-ratio="1"
                   :class="{ 'mb-5': highlighted, 'mb-6': !highlighted }">

                <card-image-overlay v-if="product.unavailable || !product.active || !product.available_in_country"
                                    :unavailable="product.unavailable"
                                    :inactive="!product.active"
                                    :availableInCountry="product.available_in_country"/>
            </v-img>
        </div>

        <v-btn v-if="product.active"
               fab
               x-small
               absolute
               right
               top
               color="secondary"
               @click.prevent="toggleWishlistItem"
               class="button-wishlist">
            <v-icon class="wishlist-btn-icon" v-if="onWishlist">mdi-heart</v-icon>
            <v-icon class="wishlist-btn-icon" v-else>mdi-heart-outline</v-icon>
        </v-btn>

        <!--<v-img v-if="product.required_rank"-->
        <!--class="wishlist-entry-card__rank mt-3 mr-3"-->
        <!--width="16px"-->
        <!--:src="product.required_rank.icon"></v-img>-->

        <div class="py-0 body-1 text-uppercase" :class="{ 'px-5': highlighted }">
            {{ product.product_brand }}
        </div>
        <div class="pt-0 font-weight-bold"
             :class="{ 'headline': highlighted, 'body-1': !highlighted, 'px-5': highlighted, 'mb-2': highlighted, 'mb-4': !highlighted }">
            {{ product.title }}
        </div>
        <div class="mt-auto pb-0"
             :class="{ 'px-5': highlighted }">
            {{ product.price | number }} {{ $vuetify.lang.t('$vuetify.points.long') }}
        </div>
    </v-card>
</template>

<script>
    // Utils
    import { LOADER_SUBMIT_WISHLIST } from '../../utils/constants';
    // Models
    import WishlistEntry from '../../models/WishlistEntry';
    // Components
    import CardImageOverlay from '../CardImageOverlay';

    export default {
        name: 'product-card',
        components: {
            CardImageOverlay,
        },
        props: {
            product: {
                required: true,
                type: Object,
            },
            highlighted: {
                required: false,
                type: Boolean,
            },
            category: {
                required: false,
                type: Boolean,
            },
        },
        computed: {
            onWishlist() {
                return WishlistEntry.query().where('product_id', this.product.id).get().length > 0;
            },
            whileSubmittingWishlist() {
                return this.$wait.is(LOADER_SUBMIT_WISHLIST);
            },
        },
        methods: {
            async toggleWishlistItem() {
                if (this.whileSubmittingWishlist) return;
                if (this.onWishlist) {
                    await WishlistEntry.remove(this.product.id);
                } else {
                    await WishlistEntry.add(this.product.id);
                }
            },
            productImageSrc(product) {
                return product.images.length > 0 ? product.images[0].source : '//via.placeholder.com/150x150/a1a1a1/FF0000/?text=Fallback';
            },
        },
    }
</script>
